import MigrationShouldRun from 'api/migrate/MigrationShouldRun'
import UpdateVersion from 'api/migrate/UpdateVersion'

/**
 * Run the migration if version is less than the config.
 *
 * @param {Object} config
 */
export default function (config) {
  const MIGRATION_TO_VERSION = 0

  if (MigrationShouldRun(config, MIGRATION_TO_VERSION)) {
    // Run migration scripts here...
    UpdateVersion(config, MIGRATION_TO_VERSION)
  }

  return config
}
